import { invertMap } from '@src/slide/infrastructure/module/independent/object/map-invert';
import { STTextUnderlineType } from '@tencent/slide-sdk-model';

// 下划线 - sdk对上层类型映射
export const TEXT_UNDERLINE_TYPE_SDK2UI_MAP = new Map([
    [STTextUnderlineType.none, 'none'],
    [STTextUnderlineType.sng, 'underline'],
]);

// 下划线 - 上层类型对sdk的映射
export const TEXT_UNDERLINE_TYPE_UI2SDK_MAP = invertMap(TEXT_UNDERLINE_TYPE_SDK2UI_MAP);
